<template>
  <div class="w-100">
    <grid-component
      isResizable
      isReorderable
      :canEdit="checkClaim(CAN_EDIT_QUOTES)"
      :canDelete="checkClaim(CAN_DELETE_QUOTES)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :checkBoxValues="checkedRowItemIds"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :handleRowClick="onRowClick"
      :navigationField="'partNumber'"
      @checkedItem="checkedRowItemIds = $event"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import debounce from 'lodash/debounce';

import { SORT_ORDER, GRID_ID } from '@/shared/constants';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridSettings,
    GridComponent,
  },
  props: {
    quoteId: {
      type: [Number, String],
      default: 0,
    },
    showAllGridRows: {
      type: [Boolean],
      default: false,
    },
    hideDelete: {
      type: [Boolean],
      default: false,
    },
    hideEdit: {
      type: [Boolean],
      default: false,
    },
    hideCheckBox: {
      type: [Boolean],
      default: false,
    },
  },
  data: () => ({
    prepareColumnsData,
    selectedRowItemId: 0,
    gridId: GRID_ID.QUOTE_LINES,
    fields: gridFields,
    checkedRowItemIds: [],
  }),
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('quoteLines', ['quoteLinesById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    sortDetails: function() {
      if (this.sortBy) {
        return [{ field: this.sortBy, dir: this.sortOrder.toLowerCase() }];
      }

      if (this.gridSettings.sort) {
        return [
          {
            field: this.gridSettings.sort.sortBy,
            dir: this.gridSettings.sort.sortOrder.toLowerCase(),
          },
        ];
      }

      return [];
    },
    quoteLines() {
      return this.quoteLinesById(this.quoteId);
    },
    itemData() {
      return this.quoteLines.map(quoteLine => ({
        ...quoteLine,
        selected: quoteLine.id === this.selectedRowItemId,
      }));
    },
    checkAllRows: {
      get() {
        return false;
        //return this.quoteLines && this.quoteLines.length ? this.checkedRowItemIds.length === this.quoteLines.length : false;
      },
      set(value) {
        const checked = [];

        if (value) {
          this.quoteLines.forEach(quoteLine => {
            checked.push(quoteLine.id);
          });
        }

        this.checkedRowItemIds = checked;
      },
    },
  },
  methods: {
    ...mapActions('quoteLines', [
      'getByQuoteId',
      'deleteQuoteLine',
      // 'updateQuoteLine',
      // 'createQuoteLine',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    handleColumnResize: debounce(function({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: {
          columns: newColumns,
        },
      });
    }, 500),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: fields,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({
        id: this.gridId,
        settings: {
          columns: newColumns,
        },
      });
    },
    onEdit(data) {
      console.log('quote line onEdit');
      this.$emit('showEdit', data);
    },
    async onDelete(item) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete quoteLine with id :${item.id}?`});
      if (deleteConfirmed) {
        const result = await this.deleteQuoteLine(item.id);
        // this.$emit('updateTotal', result);
        this.getByQuoteId(this.quoteId);
      }
    },
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;

      //const selectedQuoteLine = quoteLines.find(quoteLine => quoteLine.id === selectedRowItemId);

      this.$emit('selectedQuoteLine', row.dataItem);
    },
  },
  watch: {
    quoteId() {
      if (this.quoteId > 0) {
        this.getByQuoteId(this.quoteId);
      }
    },
    showAllGridRows(newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    },
    checkedRowItemIds() {
      this.$emit('updateCheckedRowItemIds', this.checkedRowItemIds);
    },
  },
  mounted() {
    if (this.quoteId > 0) {
      this.getByQuoteId(this.quoteId).then(() => {
        if (this.quoteLines.length > 0) {
          this.selectedRowItemId = this.quoteLines[0].id;
          this.$emit('selectedQuoteLine', this.quoteLines[0]);
        }
      });
    }
  },
};
</script>

<style lang="scss">
.quotes--quote-lines {
  .invisible-column {
    width: 0;
  }
}

.quotes--quote-lines-grid {
  height: 185px !important;
}
</style>
